"use client";

import { ThemeProvider as StyledThemeProvider } from "styled-components";
import { ReactNode, useMemo } from "react";
import Theme, { ImportTheme } from "@template/theme/types/Theme.types.ts";

type ThemeProviderProps = {
  children: ReactNode;
} & ({ theme: ImportTheme; type: "import" } | { theme: Theme; type: "local" });

const ThemeProvider = ({
  theme,
  children,
  type = "import",
}: ThemeProviderProps) => {
  const isLocal = type === "local";
  const modifiedTheme: Theme = useMemo((): Theme => {
    if (isLocal) return theme as Theme;

    const breakpoints = theme.breakpoints;
    const mediaQueries = Object.keys(breakpoints).reduce(
      (acc: any, key: string) => {
        acc[key] = {
          value: (breakpoints as any)[key],
          query: `@media (max-width: ${(breakpoints as any)[key]}px)` as any,
        };
        return acc;
      },
      {} as Theme["breakpoints"]
    );

    return {
      ...theme,
      breakpoints: mediaQueries,
    };
  }, [theme, type]);

  return (
    <StyledThemeProvider theme={modifiedTheme}>{children}</StyledThemeProvider>
  );
};

export default ThemeProvider;
